export const denoiseWasm = new URL('./denoise_bg.wasm', import.meta.url);
